import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
    AdminSettings,
    AdminSettingsResponse,
    UpdateAdminSettingsPayload,
    UpdateAdminSettingsResponse,
} from "../../interface/admin_settings.interface";

/**
 * ============================================
 * ⚙️ ADMIN SETTINGS SERVICE
 * ============================================
 */

class AdminSettingsService {
    /**
     * 📥 GET SETTINGS
     */
    async getSettings(): Promise<AdminSettings> {
        const response = await apiClient.get<AdminSettingsResponse>(
            env.SETTINGS.ADMIN
        );

        return response.data.data.settings;
    }

    /**
     * ✏️ UPDATE SETTINGS (JSON)
     */
    async updateSettings(
        data: UpdateAdminSettingsPayload
    ): Promise<string> {
        const response = await apiClient.put<UpdateAdminSettingsResponse>(
            env.SETTINGS.UPDATE,
            data
        );

        return response.data.message;
    }

    /**
     * 🖼️ UPLOAD MEDIA
     */
    async uploadMedia(files: {
        logo?: File;
        logo_dark?: File;
        favicon?: File;
        cover_image?: File;
        hero_image?: File;
        og_image?: File;
        founder_photo?: File; // ✅ ajout
    }): Promise<string> {
        const formData = new FormData();

        Object.entries(files).forEach(([_, file]) => {
            if (file) {
                formData.append(_, file);
            }
        });

        const response = await apiClient.post(
            env.SETTINGS.MEDIA,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return response.data.message;
    }
}

/**
 * Export instance
 */
export const adminSettingsService = new AdminSettingsService();